import { AxiosResponse } from 'axios';
import apiInterceptor from '../utils/axios';
import { Categoria } from '../types/Categoria/Categoria';
import { ResponseApi } from '../types/Response/ResponseApi';

const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';
const APICATEGORIAS = 'api/Catalog/Categorias/';

export default class CategoriasService {
    static async GetCategorias(page: number = 1, pageSize: number = 25): Promise<ResponseApi<Categoria>> {
        const response: AxiosResponse<ResponseApi<Categoria>> = await apiInterceptor.get(
            `${SERV_BACK}${APICATEGORIAS}?page=${page}&pageSize=${pageSize}`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async GetCategoriasByName(key: string,page: number = 1, pageSize: number = 25): Promise<ResponseApi<Categoria>> {
        const response: AxiosResponse<ResponseApi<Categoria>> = await apiInterceptor.get(
            `${SERV_BACK}${APICATEGORIAS}byName/${key}?page=${page}&pageSize=${pageSize}`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async GetCategoriasActivas(): Promise<ResponseApi<Categoria>> {
        const response: AxiosResponse<ResponseApi<Categoria>> = await apiInterceptor.get(
            `${SERV_BACK}${APICATEGORIAS}Actives`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async ActivarCategoria(id: number): Promise<ResponseApi<Categoria>> {
        const response: AxiosResponse<ResponseApi<Categoria>> = await apiInterceptor.put(
            `${SERV_BACK}${APICATEGORIAS}Activate/${id}`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async InactivarCategoria(id: number): Promise<ResponseApi<Categoria>> {
        const response: AxiosResponse<ResponseApi<Categoria>> = await apiInterceptor.put(
            `${SERV_BACK}${APICATEGORIAS}Inactivate/${id}`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async EditarCategoria(obj: Categoria): Promise<ResponseApi<Categoria>> {
        const response: AxiosResponse<ResponseApi<Categoria>> = await apiInterceptor.put(
            `${SERV_BACK}${APICATEGORIAS}${obj.idCategoria}`,
            obj,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }

    static async CrearCategoria(obj: Categoria): Promise<ResponseApi<Categoria>> {
        const response: AxiosResponse<ResponseApi<Categoria>> = await apiInterceptor.post(
            `${SERV_BACK}${APICATEGORIAS}`,
            obj,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    }
}